import * as React from "react";
import { Text, Caption1, tokens } from "@fluentui/react-components";

interface SettingRowProps {
  label: string;
  description: string;
  children: React.ReactNode;
}

const SettingRow: React.FC<SettingRowProps> = ({ label, description, children }) => {
  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "12px 0",
      gap: "18px",
      borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <Text weight="semibold">{label}</Text>
        <Caption1>{description}</Caption1>
      </div>
      <div>
        {children}
      </div>
    </div>
  );
};

export default SettingRow;